import { render, staticRenderFns } from "./LaboratoryProfileComponent.vue?vue&type=template&id=78ec1689&scoped=true&"
import script from "./LaboratoryProfileComponent.vue?vue&type=script&lang=js&"
export * from "./LaboratoryProfileComponent.vue?vue&type=script&lang=js&"
import style0 from "./LaboratoryProfileComponent.vue?vue&type=style&index=0&id=78ec1689&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ec1689",
  null
  
)

export default component.exports